import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gr-rate-limiting-settings',
  templateUrl: './gr-rate-limiting-settings.component.html',
  styleUrls: ['./gr-rate-limiting-settings.component.scss']
})
export class GrRateLimitingSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
